import {
  BOOKING_ID_QUERY_PARAM,
  CONFIRMATION_ACCESS,
  FLIGHT_SESSION_QUERY_PARAM,
} from '../constants/sessionRoute.constants';

export function presentQueryValue(value) {
  return String(value ?? '').trim();
}

export function resolveConfirmationAccess({ bookingId, isAuthenticated, authLoading }) {
  if (authLoading) return CONFIRMATION_ACCESS.WAIT;
  if (presentQueryValue(bookingId)) return CONFIRMATION_ACCESS.SHOW;
  if (isAuthenticated) return CONFIRMATION_ACCESS.PROFILE;
  return CONFIRMATION_ACCESS.LOGIN;
}

export function buildFlightConfirmationPath({ sessionId, bookingId } = {}) {
  const params = new URLSearchParams();
  const sid = presentQueryValue(sessionId);
  const id = presentQueryValue(bookingId);
  if (sid) params.set(FLIGHT_SESSION_QUERY_PARAM, sid);
  if (id) params.set(BOOKING_ID_QUERY_PARAM, id);
  const query = params.toString();
  return query ? `/booking-confirmation?${query}` : '/booking-confirmation';
}
